var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "removehold"
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_c('div', {
    staticClass: "card-header filter_main"
  }, [_c('i', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse1",
      modifiers: {
        "collapse1": true
      }
    }],
    staticClass: " fa fa-filter filter",
    attrs: {
      "data-toggle": "collapse",
      "aria-expanded": "true"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  })]), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "visible": "",
      "id": "collapse1"
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('removeHold.drNo')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-user'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('removeHold.drNoPlaceHolder')
    },
    model: {
      value: (_vm.invreferenceid),
      callback: function($$v) {
        _vm.invreferenceid = $$v
      },
      expression: "invreferenceid"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('removeHold.invoiceNo')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-envelope'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('removeHold.invoiceNoPlaceholder')
    },
    model: {
      value: (_vm.invoiceno),
      callback: function($$v) {
        _vm.invoiceno = $$v
      },
      expression: "invoiceno"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "position",
    staticStyle: {
      "top": "88px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getInboundData
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('inwardList.search')))]), _vm._v(" \n              "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v("  " + _vm._s(_vm.$t('common.resetBtn')))])])])])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" " + _vm._s(_vm.$t('removeHold.inboundReceivingUser')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 cardlistheader"
  }), _vm._v(" "), (_vm.totalRows > 0) ? _c('div', {
    staticClass: "col-md-2 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('product.table.count')) + " - " + _vm._s(_vm.totalRows))])]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    attrs: {
      "id": "my-table"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "20%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('removeHold.dockReceiptNo')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "20%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('removeHold.invoiceNo')) + " ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('removeHold.poId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('printProductDetails.productId')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('removeHold.productMrp')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "5%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('removeHold.totalHoldQty')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('removeHold.holdReason')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('removeHold.holdDate')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('removeHold.holdBy')))])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    attrs: {
      "width": "10%"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('client.action')))])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listInboundData), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.invreferenceid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.invoiceno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.pono))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.mrp))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.onholdquantity))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.onholdreason))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createddate))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.createdby))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('i', {
      staticClass: "fa fa-edit text-successedit fa-lg mt-2 ml-3",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeHold(data)
        }
      }
    })])])
  }), _vm._v(" "), ((_vm.listInboundData.result && _vm.listInboundData.result.length == 0) || _vm.listInboundData.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('merchant.noRecordFound')))])]) : _vm._e()], 2)]), _vm._v(" "), (_vm.pageCount > 0) ? _c('b-pagination', {
    staticClass: "mt-4",
    attrs: {
      "total-rows": _vm.pageCount * 10,
      "per-page": 10,
      "aria-controls": "my-table",
      "first-text": "⏮",
      "prev-text": "⏪",
      "next-text": "⏩",
      "last-text": "⏭"
    },
    on: {
      "input": function($event) {
        _vm.getPaginationData(_vm.currentPage)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.addholdmodal = false
      }
    },
    model: {
      value: (_vm.addholdmodal),
      callback: function($$v) {
        _vm.addholdmodal = $$v
      },
      expression: "addholdmodal"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(" " + _vm._s(_vm.$t('removeHold.removeHold')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeaddholdmodal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('common.productId')) + ":")]), _vm._v(_vm._s(this.Deatils.productid))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('removeHold.holdQty')) + ":")]), _vm._v(_vm._s(this.Deatils.onholdquantity))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('removeHold.productMrp')) + ":")]), _vm._v(_vm._s(this.Deatils.mrp))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('removeHold.holdReason')) + ":")]), _vm._v(_vm._s(this.Deatils.onholdreason))])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('orders.acceptedQty')) + ": ")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addhold.Acceptedqty),
      expression: "addhold.Acceptedqty"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Accepted Qty')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('grcList.acceptedQuantityPlaceholder'),
      "name": "Accepted Qty",
      "id": "Accepted Qty"
    },
    domProps: {
      "value": (_vm.addhold.Acceptedqty)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addhold.Acceptedqty = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Accepted Qty')),
      expression: "errors.has('Accepted Qty')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Accepted Qty')) + "\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('grcRejectReport.RejectedQty')) + ":")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addhold.rejectedqty),
      expression: "addhold.rejectedqty"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'form-control': true,
      'error': _vm.errors.has('Rejected Qty')
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('grcList.rejectedQuantityPlaceholder'),
      "name": "Rejected Qty"
    },
    domProps: {
      "value": (_vm.addhold.rejectedqty)
    },
    on: {
      "keyup": _vm.checkQty,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addhold.rejectedqty = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('Rejected Qty')),
      expression: "errors.has('Rejected Qty')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('Rejected Qty')) + "\n                ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [(_vm.isError) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.Qtyerrors))]) : _vm._e()])]), _vm._v(" "), (_vm.addhold.rejectedqty) ? _c('b-form-fieldset', [_c('label', {
    staticClass: "pref-button checkbox"
  }, [_vm._v("    \n                "), _c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAll),
      expression: "selectAll"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAll) ? _vm._i(_vm.selectAll, null) > -1 : (_vm.selectAll)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.selectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAll = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.selectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAll = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.$t('removeHold.selectAll')) + " ")])]), _vm._v("    \n              "), _c('div', {
    staticStyle: {
      "height": "100px",
      "border-style": "ridge",
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.listReasonData), function(select) {
    return _c('label', {
      key: select.reasonid,
      staticClass: "pref-button checkbox",
      staticStyle: {
        "padding-left": "10pt",
        "padding-right": "10pt",
        "padding-top": "5pt",
        "width": "20%"
      },
      attrs: {
        "for": select.reasonid
      }
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selected),
        expression: "selected"
      }],
      class: select.class,
      attrs: {
        "type": "checkbox",
        "id": select.reasonid,
        "sector": select.reasonid
      },
      domProps: {
        "value": select.reasonname,
        "checked": Array.isArray(_vm.selected) ? _vm._i(_vm.selected, select.reasonname) > -1 : (_vm.selected)
      },
      on: {
        "__c": function($event) {
          var $$a = _vm.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = select.reasonname,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selected = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selected = $$c
          }
        }
      }
    }), _vm._v(_vm._s(select.reasonname)), _c('span', {
      staticClass: "cr"
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])])])
  }))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "clientfooter form-actions",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.saveHoldQtyData
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.saveBtn')) + " ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeaddholdmodal
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancelBtn')) + " ")]), _c('br')])])])])])], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-525f803c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-525f803c","hasScoped":true}!./src/views/components/removehold/removehold.component.html
// module id = 1582
// module chunks = 0